module.exports = __webpack_public_path__ + "static/phone_se-f366cdaa7431156fcf1d03c4af85b799.png";